import { render, staticRenderFns } from "./DialogParametriRegistro.vue?vue&type=template&id=71be1947&"
import script from "./DialogParametriRegistro.vue?vue&type=script&lang=js&"
export * from "./DialogParametriRegistro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports